/**
 * Window events that tie the shell's global pieces together — any screen can open them
 * without importing the shell (palette, Today, automations, related settings, help, tour).
 */
export const EVENTS = {
  palette: "tb:open-palette",
  today: "tb:open-today",
  automations: "tb:open-automations",
  automationsChanged: "tb:automations-changed",
  related: "tb:open-related-settings",
  help: "tb:open-help",
  tour: "tb:open-tour",
  quickCreate: "tb:quick-create",
  dataChanged: "tb:data-changed",
  assistant: "tb:open-assistant",
} as const;

function fire(name: string, detail?: unknown) {
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

export const openPalette = (query?: string) => fire(EVENTS.palette, { query });
export const openToday = () => fire(EVENTS.today);
/** tab "ai" opens the automation designer, optionally sending `prompt` right away */
export const openAutomations = (detail: { tab?: "here" | "available" | "ai"; prompt?: string | null } = {}) =>
  fire(EVENTS.automations, detail);
export const notifyAutomationsChanged = () => fire(EVENTS.automationsChanged);
export const openRelatedSettings = () => fire(EVENTS.related);
export const openHelpCenter = (slug?: string | null) => fire(EVENTS.help, { slug: slug ?? null });
export const openDesignTour = () => fire(EVENTS.tour);
/** AI assistant — optionally with a question to send right away */
export const openAssistant = (prompt?: string) => fire(EVENTS.assistant, { prompt: prompt ?? null });
/** Something was created / changed — open lists and the Today panel refresh. */
export const notifyDataChanged = (entity: string) => fire(EVENTS.dataChanged, { entity });

export function onEvent<T = unknown>(name: string, handler: (detail: T) => void): () => void {
  const fn = (e: Event) => handler((e as CustomEvent<T>).detail);
  window.addEventListener(name, fn);
  return () => window.removeEventListener(name, fn);
}
